module.exports = __webpack_public_path__ + "img/women-in-car.9581a3b3.jpg";